import { OnboardingFragment } from 'graphql/generated/graphql';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

type Props = {
    onboarding: OnboardingFragment;
};

const OnboardingMetaTagHead = ({ onboarding }: Props) => {
    const {
        locale,
        query: { company, product },
    } = useRouter();

    const url = useMemo(
        () => `https://${company}.pimster.app/${product}/onboarding`,
        [company, product]
    );

    const structuredData = useMemo(
        () => ({
            '@context': 'http://schema.org/',
            '@type': 'WebPage',
            name: onboarding.Title,
            url,
        }),
        [onboarding.Title, url]
    );

    return (
        <Head>
            {/* Generic */}
            <title>{onboarding.Title || 'Onboarding'}</title>
            <meta name='robots' content='indexifembedded' />
            <meta
                name='title'
                content={onboarding.Title || 'Onboarding Title'}
            />
            <meta name='description' content='Onboarding Description' />

            {/* OpenGraph */}
            <meta
                property='og:title'
                content={onboarding.Title || 'Onboarding'}
            />
            <meta property='og:type' content='video.other' />
            <meta property='og:url' content={url} />
            <meta property='locale' content={locale} />
            <meta property='og:description' content='Onboarding Description' />

            {/* Twitter */}
            <meta property='twitter:card' content='summary_large_image' />
            <meta property='twitter:url' content={url} />
            <meta
                property='twitter:title'
                content={onboarding.Title || 'Onboarding'}
            />
            <meta
                property='twitter:description'
                content='Onboarding Description'
            />

            {/* Prevent zoon after input focus on Mozilla */}
            <meta
                name='viewport'
                content='width=device-width, height=device-height, initial-scale=1, minimum-scale=1, maximum-scale=1'
            />

            {/* Structured Data */}

            <script type='application/ld+json'>
                {JSON.stringify(structuredData)}
            </script>
        </Head>
    );
};

export default OnboardingMetaTagHead;
